/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Ask_5Inputs */

const en_cp_ask_5 = /** @type {(inputs: Cp_Ask_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Communities: Bystep logo on competition material + one intro session`)
};

const id_cp_ask_5 = /** @type {(inputs: Cp_Ask_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komunitas: logo Bystep di materi lomba + 1 sesi sosialisasi`)
};

/**
* | output |
* | --- |
* | "Communities: Bystep logo on competition material + one intro session" |
*
* @param {Cp_Ask_5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_ask_5 = /** @type {((inputs?: Cp_Ask_5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Ask_5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_ask_5(inputs)
	return en_cp_ask_5(inputs)
});